var app = angular.module('leonardo');

var CountryService = function(BaseRestService) {
  var service = new BaseRestService('countries');

  service.dateFormats = [
    { id: 'MM/DD/YYYY', name: 'MM/DD/YYYY (02/17/2009)'},
    { id: 'DD/MM/YYYY', name: 'DD/MM/YYYY (17/02/2009)'},
    { id: 'YYYY/MM/DD', name: 'YYYY/MM/DD (2009/02/17)'},
    { id: 'MM-DD-YYYY', name: 'MM-DD-YYYY (02-17-2009)'},
    { id: 'DD-MM-YYYY', name: 'DD-MM-YYYY (17-02-2009)'},
    { id: 'YYYY-MM-DD', name: 'YYYY-MM-DD (2009-02-17)'},
  ];

  return service;
};

app.factory('CountryService', ['BaseRestService', CountryService]);

